<div class="automation">
  @if (!isAvaGP) {
    <div class="header-tab-row">
      <div class="item-tab" [ngClass]="{'active': (isCurrentUrl('') || isCurrentUrl('/ava-followup'))}">
        <a routerLink="ava-followup">
          <div class="item">AVA’S FOLLOW UP</div>
        </a>
      </div>
      <div class="item-tab" [ngClass]="{'active': (isCurrentUrl('') || isCurrentUrl('/chat-dashboard'))}" *featureIf="'ava-chat'">
        <a routerLink="chat-dashboard">
          <div class="item">AVA CHAT</div>
        </a>
      </div>
      <div class="item-tab count-record" [ngClass]="{'active':isCurrentUrl('/virtual-consult')}">
        <a routerLink="virtual-consult">
          <div id="automations-tab-virtual-consult" class="item">VIRTUAL CONSULT</div>
        </a>
        @if (isCurrentUrl('/virtual-consult')) {
          <div class="count-record-batch" (click)="showWins('vc')">
            <div class="transparent-gray"></div>{{leaddata.length}}
          </div>
        }
      </div>
      <div class="item-tab count-record" [ngClass]="{'active':isCurrentUrl('/new-patient-scheduler')}">
        <a routerLink="new-patient-scheduler">
          <div id="automations-tab-new-patient-scheduler" class="item">NEW PATIENT SCHEDULER</div>
        </a>
        @if (isCurrentUrl('/new-patient-scheduler')) {
          <div class="count-record-batch" (click)="showWins('nps')">
            <div class="transparent-gray"></div>{{npsdata.length}}
          </div>
        }
      </div>
      <div class="item-tab count-record" [ngClass]="{'active':isCurrentUrl('/new-patient-tracker')}">
        <a routerLink="new-patient-tracker">
          <div id="automations-tab-new-patient-tracker" class="item">NEW PATIENT TRACKER</div>
        </a>
      </div>
      <!-- <div class="item-tab" [ngClass]="{'active':isCurrentUrl('/rcm-dashboard')}">
      <a routerLink="rcm-dashboard">
        <div id="automations-tab-rcm-dashboard" class="item">AVA'S RCM DASHBOARD</div>
      </a>
    </div> -->
    @if (false) {
      <div class="item-tab" [ngClass]="{'active':isCurrentUrl('/patient-follow-up')}">
        <a routerLink="patient-follow-up">
          <div id="automations-patient-follow-up" class="item">PATIENT FOLLOW UP</div>
        </a>
      </div>
    }
    @if (false) {
      <div class="item-tab" [ngClass]="{'active':isCurrentUrl('/reminders')}">
        <a routerLink="reminders">
          <div id="automations-tab-reminders" class="item">REMINDERS</div>
        </a>
      </div>
    }
    <select id="automation_category" name="automation_category" (change)="gotoURL($event.target.value)">
      <option value="" [selected]="isCurrentUrl('')">AVA’S FOLLOW UP</option>
      <option *featureIf="'ava-chat'" value="chat-dashboard" [selected]="isCurrentUrl('/chat-dashboard')">AVA CHAT</option>
      <option value="virtual-consult" [selected]="isCurrentUrl('/virtual-consult')">VIRTUAL CONSULT</option>
      <option value="new-patient-scheduler" [selected]="isCurrentUrl('/new-patient-scheduler')">NEW PATIENT SCHEDULER
      </option>
      <option value="new-patient-tracker" [selected]="isCurrentUrl('/new-patient-tracker')">NEW PATIENT TRACKER</option>
      <option value="case-presentation" [selected]="isCurrentUrl('/case-presentation')">CASE PRESENTATION</option>
      @if (false) {
        <option value="patient-follow-up" [selected]="isCurrentUrl('/patient-follow-up')">PATIENT FOLLOW UP
        </option>
      }
      @if (false) {
        <option value="reminders" [selected]="isCurrentUrl('/reminders')">REMINDERS</option>
      }
    </select>
  </div>
}
<div class="components-container">
  <router-outlet></router-outlet>
</div>
</div>
